<template>
  <div v-show="dataLoaded">
    <div v-if='enabled'>
    <c-row>
      <c-col span="12">
        <div class="u-h5">API access is enabled</div>
        <div class="u-fs-12">&nbsp;</div>
        <c-form-field label="Client code:"
                      help="Identifies the tenant in the platform">
          <c-form-input v-model="clientCode" readonly></c-form-input>
        </c-form-field>
        <c-form-field label="API login:"
                      help="How API calls are authorized">
          <c-form-input v-model="userLogin" readonly></c-form-input>
        </c-form-field>
        <c-form-field label="Application code:"
                      help="Application code to be used for authorization (don't forget to prefix it with app, see code on right pane)">
          <c-form-input v-model="applicationCode" readonly></c-form-input>
        </c-form-field>
        <c-button type="primary" @click="onConfirmGenerateNewKeys">GENERATE NEW API SECRET</c-button>
        <c-form-field label="API Secret:"
                      help="Secret to be used for authorization" v-if="secret != null">
          <c-form-input v-model="secret" readonly></c-form-input>
        </c-form-field>
      </c-col>
      <c-col span="10">
        <pre>
          <code language="python">
requests.post('https://portal.doqument.ro/idp/connect/token', data={
  'client_id': f'app{{this.applicationCode}}',
  'client_secret': f'{{this.secret != null ? this.secret : "[YOUR SECRET]"}}',
  'grant_type': "client_credentials"
}, headers={
  'Content-Type': 'application/x-www-form-urlencoded'
})
          </code>
        </pre>
      </c-col>
    </c-row>
      </div>
    <div v-else>
      <span class="u-h5 u-color-danger">API access is not enabled</span>
    </div>
    <c-modal title="Confirm the operation" v-model="showConfirmation">
      <c-row>You are about to generate a new secret for your API credentials.</c-row>
      <c-row class="u-pb-10 u-pt-10"><span class="u-font-bold u-color-danger">The operation cannot be undone.</span></c-row>
      <c-row>Please copy the generated secret and paste it in your API client application as it will no longer be visible in the application.</c-row>
      <div class="u-text-right" slot="footer">
        <c-button type="primary" @click="onGenerateNewKey" v-once smart>GENERATE A NEW SECRET</c-button>
      </div>
    </c-modal>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import clients from '../../services/client.service'

export default {
  name: 'ClientAPISettings',
  computed: {
    ...mapState('auth', ['clientCode', 'clientId'])
  },
  data () {
    return {
      enabled: false,
      applicationCode: null,
      secret: null,
      userLogin: null,
      dataLoaded: false,
      showConfirmation: false
    }
  },
  created () {
    this.getData()
  },
  methods: {
    getData () {
      clients.getAPISettings(this.clientCode).then((response) => {
        this.handleData(response.data)
      })
    },
    handleData (data) {
      if (data.enabled) {
        this.enabled = true
        this.applicationCode = data.application_code
        this.userLogin = data.user_login
      } else {
        this.enabled = false
      }
      this.dataLoaded = true
    },
    onConfirmGenerateNewKeys () {
      this.showConfirmation = true
    },
    async onGenerateNewKey () {
      try {
        let nk = await clients.getAPINewKeys(this.clientCode)
        this.secret = nk.data.secret
      } catch (e) {
        // ...
        this.secret = null
      }
      this.showConfirmation = false
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ClientSettings/APISettings.vue